import { rest } from 'msw'
import { DepositBankAccount } from 'types/BankAccountsDetails'
import { WalletType } from 'types/types'
import eurDepositAccounts from '../../../__mocks__/FiatDeposit/eurDepositAccounts.json'
import fiatWallets from '../../../__mocks__/FiatDeposit/fiatWallets.json'
import gbpDepositAccounts from '../../../__mocks__/FiatDeposit/gbpDepositAccounts.json'
import gbpMultipleDepositAccounts from '../../../__mocks__/FiatDeposit/gbpMultipleDepositAccounts.json'
import usdDepositAccounts from '../../../__mocks__/FiatDeposit/usdDepositAccounts.json'
import walletLegacyIdMappings from '../../../__mocks__/FiatDeposit/walletLegacyIdMappings.json'
import zarDepositAccounts from '../../../__mocks__/FiatDeposit/zarDepositAccounts.json'

const API_URL = process.env.API_URL

// Handler for getting wallet by ID - only use in specific fiat deposit tests
export const getFiatDepositWalletById = rest.get<WalletType>(
  `${API_URL}/api/wallet/:id`,
  async (req, res, ctx) => {
    const { id } = req.params
    const wallet = fiatWallets.find(w => w.id === Number(id))

    if (wallet) {
      return res(ctx.json(wallet))
    }

    return res(ctx.status(404), ctx.json({ message: 'Wallet not found' }))
  }
)

// Handler for converting wallet LSID to legacy ID
export const getWalletLegacyIdHandler = rest.get<number>(
  `${API_URL}/api/v2/wallet/:lsid/convert-id`,
  async (req, res, ctx) => {
    const { lsid } = req.params as { lsid: string }
    const legacyId = walletLegacyIdMappings[lsid as keyof typeof walletLegacyIdMappings]

    if (legacyId) {
      return res(ctx.json(legacyId))
    }

    return res(ctx.status(404), ctx.json({ message: 'Legacy ID not found' }))
  }
)

// Handler for getting deposit accounts by wallet ID
export const getDepositAccountsByWalletId = rest.get<DepositBankAccount[]>(
  `${API_URL}/api/v2/wallet/:id/deposit-options`,
  async (req, res, ctx) => {
    const { id } = req.params
    const wallet = fiatWallets.find(w => w.id === Number(id))

    if (!wallet) {
      return res(ctx.status(404), ctx.json({ message: 'Wallet not found' }))
    }

    // Return deposit accounts based on currency
    let accounts: DepositBankAccount[] = []

    // Wallet ID 5 returns multiple GBP deposit accounts for testing
    if (wallet.id === 5) {
      accounts = gbpMultipleDepositAccounts as DepositBankAccount[]
    } else {
      switch (wallet.currency.code) {
        case 'GBP':
          accounts = gbpDepositAccounts as DepositBankAccount[]
          break
        case 'EUR':
          accounts = eurDepositAccounts as DepositBankAccount[]
          break
        case 'USD':
          accounts = usdDepositAccounts as DepositBankAccount[]
          break
        case 'ZAR':
          accounts = zarDepositAccounts as DepositBankAccount[]
          break
        default:
          accounts = []
      }
    }

    return res(ctx.json(accounts))
  }
)

export const fiatDepositHandlers = [getWalletLegacyIdHandler, getDepositAccountsByWalletId]
